"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = require("../../form-constants");
exports.defaultValues = {
    type: form_constants_1.requireType.ALL,
    requireCompleteResponse: false,
};
//# sourceMappingURL=required-definition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/required-definition/required-definition.js
// module id = 1134
// module chunks = 0